import { AlertOctagon, AlertTriangle, Info, CheckCircle2 } from "lucide-react";
import { useI18n } from "../lib/i18n";

const MAP = {
  Critical: { icon: AlertOctagon, cls: "bg-rose-100 text-rose-900 border-rose-300" },
  High: { icon: AlertTriangle, cls: "bg-amber-100 text-amber-900 border-amber-300" },
  Medium: { icon: Info, cls: "bg-sky-100 text-sky-900 border-sky-300" },
  Low: { icon: CheckCircle2, cls: "bg-slate-100 text-slate-800 border-slate-300" },
};

export const Severity = ({ value, testId }) => {
  const { tv } = useI18n();
  const m = MAP[value];
  if (!m) return <span>{value}</span>;
  const Icon = m.icon;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-lg border px-2 py-0.5 text-xs font-semibold ${m.cls}`}>
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      {tv(value)}
    </span>
  );
};

export const StatusPill = ({ value, testId }) => {
  const { tv } = useI18n();
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2 py-0.5 text-xs font-medium text-slate-700">
      <span className="h-1.5 w-1.5 rounded-full bg-sky-600" aria-hidden="true" />
      {tv(value)}
    </span>
  );
};

export const SEVERITIES = ["Critical", "High", "Medium", "Low"];
